import {
    TEAM_REQUEST_LIST_REQUEST,
    TEAM_REQUEST_LIST_SUCCESS,
    TEAM_REQUEST_LIST_FAILURE
} from "../constants"

import {
    p_cinout_logs,
    get_certificate_template,
    p_trequest_users,
    pharmacy_assign_certificate,
    pharmacy_certificate_template,
    pharmacy_task,
    puser_attendance_sheet,
    pharmacy_team_users,
    pharmacy_user_departments,
    pharmacy_group_list,
    on_boarding_user_profile,
    pharmacy_task_conversation
} from "../../../../networking/urlEndPoints"

import Axios from "../../../../networking/intraceptor"
import { actionTypes, createAction } from "../../../reducers/pharmacy/other/commonReducerForInitalData"
import { formatDateToYYYYMMDD_CA } from "../../../../utils/constants/formInitialStates"

export const fetchTeamsListRequest = (fetchType) => ({
    type: TEAM_REQUEST_LIST_REQUEST,
    fetchType: fetchType
})

export const fetchTeamsListSuccess = (data, fetchType) => ({
    type: TEAM_REQUEST_LIST_SUCCESS,
    payload: data,
    fetchType: fetchType
})

export const fetchTeamsListFailure = (error, fetchType) => ({
    type: TEAM_REQUEST_LIST_FAILURE,
    payload: error,
    fetchType: fetchType
})

export const fetchTimeOffRequestList = (type, params) => {
    return async (dispatch) => {
        dispatch(fetchTeamsListRequest(type))
        try {
            const newParams = {
                ...params,
                start_date: formatDateToYYYYMMDD_CA(params.start_date),
                end_date: formatDateToYYYYMMDD_CA(params.end_date)
            }
            const response = await Axios.get(`${p_trequest_users}`, {
                params: newParams
            })
            if (response?.status === 200) {
                dispatch(fetchTeamsListSuccess(response?.data, type))
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(fetchTeamsListFailure(error?.response, type))
            }
        }
    }
}

export const fetchAllTaskLists = (type, status, pageNumber, formData) => {
    return async (dispatch) => {
        dispatch(fetchTeamsListRequest(type))
        try {
            const params = {
                no_of_records: 25,
                type: status,
                page: pageNumber,
                status_update_date: formData?.search_date
            }
            const response = await Axios.get(`${pharmacy_task}`, {
                params
            })
            if (response?.status === 200) {
                dispatch(fetchTeamsListSuccess(response?.data, type))
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(fetchTeamsListFailure(error?.response, type))
            }
        }
    }
}

export const fetchPharmacyEmployeesTaskList = (type, params) => {
    return async (dispatch) => {
        dispatch(fetchTeamsListRequest(type))
        try {
            const response = await Axios.get(`${pharmacy_task}/singleuser`, {
                params
            })
            if (response?.status === 200) {
                dispatch(fetchTeamsListSuccess(response?.data, type))
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(fetchTeamsListFailure(error?.response, type))
            }
        }
    }
}

export const fetchPharmacyEmployeesAssignedTaskList = (type, status, pageNumber, formData) => {
    return async (dispatch) => {
        dispatch(fetchTeamsListRequest(type))
        try {
            const params = {
                no_of_records: 25,
                type: status,
                page: pageNumber,
                status_update_date: formData?.search_date
            }
            const response = await Axios.get(`${pharmacy_task}/singleuser`, {
                params
            })
            if (response?.status === 200) {
                dispatch(fetchTeamsListSuccess(response?.data, type))
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(fetchTeamsListFailure(error?.response, type))
            }
        }
    }
}

export const fetchPharmacyTeamTimeSheet = (type, reqData, silent = false) => {
    return async (dispatch) => {
        // A silent refetch keeps the current list rendered so the page doesn't jump back to the top
        if (!silent) dispatch(fetchTeamsListRequest(type))
        try {
            const newParams = {
                ...reqData,
                start_date: formatDateToYYYYMMDD_CA(reqData?.start_date),
                end_date: formatDateToYYYYMMDD_CA(reqData?.end_date)
            }
            const response = await Axios.get(`${puser_attendance_sheet}`, {
                params: newParams
            }) 
            if (response?.status === 200) {
                dispatch(fetchTeamsListSuccess(response?.data, type))
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(fetchTeamsListFailure(error?.response, type))
            }
        }
    }
}

export const fetchCertificateTemplates = (type, params) => {
    return async (dispatch) => {
        dispatch(fetchTeamsListRequest(type))
        try {
            const response = await Axios.get(`${pharmacy_certificate_template}`, {
                params
            })
            if (response?.status === 200) {
                dispatch(fetchTeamsListSuccess(response?.data, type))
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(fetchTeamsListFailure(error?.response, type))
            }
        }
    }
}

export const fethEmployeeAssignedCertificateList = (type, params) => {
    return async (dispatch) => {
        dispatch(fetchTeamsListRequest(type))
        try {
            const response = await Axios.get(`${pharmacy_assign_certificate}`, {
                params
            })
            if (response?.status === 200) {
                dispatch(fetchTeamsListSuccess(response?.data, type))
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(fetchTeamsListFailure(error?.response, type))
            }
        }
    }
}


export const fetchSingleTemplate = (type, id) => {
    return async (dispatch) => {
        dispatch(fetchTeamsListRequest(type))
        try {
            const response = await Axios.get(`${get_certificate_template}?template_id=${id}`)

            if (response?.status === 200) {
                dispatch(fetchTeamsListSuccess(response?.data, type))
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(fetchTeamsListFailure(error?.response, type))
            }
        }
    }
}

export const fetchPharmacyTeamsList = (type, params) => {
    return async (dispatch) => {
        dispatch(fetchTeamsListRequest(type))
        try {
            const response = await Axios.get(`${pharmacy_team_users}`, { params })
            if (response?.status === 200) {
                dispatch(fetchTeamsListSuccess(response?.data, type))
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(fetchTeamsListFailure(error?.response, type))
            }
        }
    }
}

export const fetchCheckOutInLogsList = (type, params) => {
    return async (dispatch) => {
        dispatch(fetchTeamsListRequest(type))
        try {
            const response = await Axios.get(`${p_cinout_logs}`, {
                params
            })
            if (response?.status === 200) {
                dispatch(fetchTeamsListSuccess(response?.data, type))
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(fetchTeamsListFailure(error?.response, type))
            }
        }
    }
}

// ------------------------------------------Pharmacy Settings List-------------------------------------------


export const fetchPharmacySettingsList = (type) => {
    return async (dispatch) => {
        dispatch(fetchTeamsListRequest(type))
        try {
            const response = await Axios.get(`pharmacy-all-setting`)
            if (response?.status === 200) {
                dispatch(fetchTeamsListSuccess(response?.data, type))
                dispatch(
                    createAction(actionTypes.UPDATE_PHARMACY_WITNESS_CARRY.SUCCESS, {
                        data: response?.data?.data?.auto_carry_witness,
                    })
                );
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(fetchTeamsListFailure(error?.response, type))
            }
        }
    }
}

export const fetchPharmacyDepartmentAssigns = (type, params, setisLoaded = '') => {
    return async (dispatch) => {
        dispatch(fetchTeamsListRequest(type))
        try {

            if (typeof setisLoaded === 'function') {
                setisLoaded(false)
            }

            const response = await Axios.get(`${pharmacy_user_departments}`, {
                params
            })
            if (response?.status === 200) {

                dispatch(fetchTeamsListSuccess(response?.data, type))
                if (typeof setisLoaded === 'function') {
                    setisLoaded(true)
                }
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(fetchTeamsListFailure(error?.response, type))
            }
        }
    }
}

export const fetchPharmacyDeliverySettingsList = (type) => {
    return async (dispatch) => {
        dispatch(fetchTeamsListRequest(type))
        try {
            const response = await Axios.get(`update-delivery-time-setting`)
            if (response?.status === 200) {
                dispatch(fetchTeamsListSuccess(response?.data, type))
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(fetchTeamsListFailure(error?.response, type))
            }
        }
    }
}

export const fetchPharmacySettings = (type) => {
    return async (dispatch) => {
        dispatch(fetchTeamsListRequest(type))
        try {


            const response = await Axios.get(`getPharmacyPermissions`)
            if (response?.status === 200) {

                dispatch(fetchTeamsListSuccess(response?.data, type))

            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(fetchTeamsListFailure(error?.response, type))
            }
        }
    }
}


export const fetchPharmacyUser = (type) => {
    return async (dispatch) => {
        dispatch(fetchTeamsListRequest(type))
        try {


            const response = await Axios.get(`${pharmacy_group_list}`)
            if (response?.status === 200) {

                dispatch(fetchTeamsListSuccess(response?.data, type))

            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(fetchTeamsListFailure(error?.response, type))
            }
        }
    }
}


export const fetchBreakPayrollValues = (type, params) => {
    return async (dispatch) => {
        dispatch(fetchTeamsListRequest(type))
        try {
            const response = await Axios.get(`/pharmacy-settings`, { params })
            if (response?.status === 200) {
                dispatch(fetchTeamsListSuccess(response?.data, type))
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(fetchTeamsListFailure(error?.response, type))
            }
        }
    }
}


export const fetchPharmacyTeamScheduleList = (type, reqData) => {
    return async (dispatch) => {
        dispatch(fetchTeamsListRequest(type))
        try {
            const params = {
                start_date: formatDateToYYYYMMDD_CA(reqData?.start_date),
                end_date: formatDateToYYYYMMDD_CA(reqData?.end_date)
            }
            const response = await Axios.get(`/pharmacy-team-scedule`, { params: params })
            if (response?.status === 200) {
                dispatch(fetchTeamsListSuccess(response?.data, type))
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(fetchTeamsListFailure(error?.response, type))
            }
        }
    }
}

export const fetchDefaultpharmacistSettingsList = (type) => {
    return async (dispatch) => {
        dispatch(fetchTeamsListRequest(type))
        try {
            const response = await Axios.get(`default-pharmacist-setting`)
            if (response?.status === 200) {
                dispatch(fetchTeamsListSuccess(response?.data, type))
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(fetchTeamsListFailure(error?.response, type))
            }
        }
    }
}


export const fetchPharmacyTaskConversation = async (params, taskId) => {
    try {
        const response = await Axios.post(`/pharmacy-task/${taskId}/conversations/send-message-users`, params)
        if (response?.status === 200) {
            return response?.data
        } else {
            throw new Error(response)
        }
    } catch (error) {
        if (error?.response) {
            throw new Error(error?.response)
        }
    }
}

export const fetchAllTaskConversation = async (taskId, url, plogin_user_ids) => {
    if (url === 'users-reply-list') {
        try {
            const response = await Axios.get(`/pharmacy-task/${taskId}/conversations/${url}`)
            if (response?.status === 200) {
                return response?.data
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                throw new Error(error?.response)
            }
        }
    }
    else {
        try {
            const response = await Axios.post(`/pharmacy-task/${taskId}/conversations/${url}`, { plogin_user_ids })
            if (response?.status === 200) {
                return response?.data
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                throw new Error(error?.response)
            }
        }
    }
}



export const sendTaskMessage = async (taskId, messageData, userRole, userId) => {
    try {
        // Add user role and ID to message data for proper filtering
        const enhancedMessageData = {
            ...messageData,
            user_role: userRole, // 'admin' or 'user'
            user_id: userId,
            task_id: taskId
        }

        const response = await Axios.post(`${pharmacy_task_conversation(taskId)}`, enhancedMessageData)
        if (response?.status === 200) {
            return response?.data
        } else {
            throw new Error(response)
        }
    } catch (error) {
        if (error?.response) {
            throw new Error(error?.response)
        }
    }
}


export const fetchTaskUsers = async () => {
    try {
        const result = await Axios.post("/pharmacy-task/taskusers", {});
        const formattedData = result?.data?.data?.map((value) => ({
            label: value.name,
            value: value.id,
        }));
        return formattedData;
    } catch (error) {
        return [];
    }
};


